import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { CompanyService } from '@app/core';

export interface AdministrationFilterOption {
  id?: number | string | null;
  value?: number | string | null;
  name?: string | null;
  reference?: string | null;
  description?: string | null;
}

export interface AdministrationFilterResponse<T = AdministrationFilterOption> {
  data: T[];
}

@Injectable({
  providedIn: 'root',
})
export class AdministrationFilterService {
  private readonly baseUrl =
    environment.coreApiBaseUrl + '/api/Administration/get/filter';

  constructor(
    private http: HttpClient,
    private companyService: CompanyService
  ) {}

  getStates(): Observable<AdministrationFilterResponse> {
    return this.request<AdministrationFilterOption>('states');
  }

  getProjects(): Observable<AdministrationFilterResponse> {
    return this.request<AdministrationFilterOption>('projects');
  }

  getServices(): Observable<AdministrationFilterResponse> {
    return this.request<AdministrationFilterOption>('services');
  }

  getServiceTypes(): Observable<AdministrationFilterResponse> {
    return this.request<AdministrationFilterOption>('service-types');
  }

  getMbls(): Observable<AdministrationFilterResponse> {
    return this.request<AdministrationFilterOption>('mbls');
  }

  getContainerReferences(): Observable<AdministrationFilterResponse> {
    return this.request<AdministrationFilterOption>('container-refs');
  }

  getSuppliers(): Observable<AdministrationFilterResponse> {
    return this.request<AdministrationFilterOption>('suppliers');
  }

  getClients(): Observable<AdministrationFilterResponse> {
    return this.request<AdministrationFilterOption>('clients');
  }

  getAnalyticOperations(): Observable<AdministrationFilterResponse> {
    return this.request<AdministrationFilterOption>('analytic-operations');
  }

  getInvoiceOrders(): Observable<AdministrationFilterResponse> {
    return this.request<AdministrationFilterOption>('invoice-orders');
  }

  getPurchaseOrders(): Observable<AdministrationFilterResponse> {
    return this.request<AdministrationFilterOption>('purchase-orders');
  }

  private request<T = AdministrationFilterOption>(
    path: string
  ): Observable<AdministrationFilterResponse<T>> {
    const url = `${this.baseUrl}/${path}`;
    return this.http.get<AdministrationFilterResponse<T>>(url, {
      headers: this.getHeaders(),
    });
  }

  private getHeaders(): HttpHeaders {
    const companyId = this.companyService.selectedCompanyId$.value;
    if (!companyId) {
      throw new Error('No company ID selected');
    }
    return new HttpHeaders({
      companyId: companyId.toString(),
    });
  }
}
